[
   {
      "display": "true",
      "ui_columnname": "Type",
      "db_columnname": "recordType",
      "datatype": "String",
      "mappingkey": "recordType",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "false",
      "ui_columnname": "Report Date",
      "db_columnname": "reportDate",
      "datatype": "String",
      "mappingkey": "reportDate",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Order Date",
      "db_columnname": "orderDate",
      "datatype": "String",
      "mappingkey": "orderDate",
      "dropdown": "NO",
      "disabled": "true",
      "value": "",
      "dropdownvalue": "",
      "dropdowntype": "singleselect"
   },
   {
      "display": "true",
      "ui_columnname": "Route Date",
      "db_columnname": "routeDate",
      "datatype": "String",
      "mappingkey": "routeDate",
      "dropdown": "NO",
      "disabled": "true",
      "value": "",
      "dropdownvalue": "",
      "dropdowntype": "singleselect"
   },
   {
      "display": "true",
      "ui_columnname": "Symbol",
      "db_columnname": "symbol",
      "datatype": "String",
      "mappingkey": "symbol",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Order ID",
      "db_columnname": "orderID",
      "datatype": "String",
      "mappingkey": "orderID",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Route ID",
      "db_columnname": "routeID",
      "datatype": "String",
      "mappingkey": "routeID",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "OMS Order ID",
      "db_columnname": "OMSOrderID",
      "datatype": "String",
      "mappingkey": "OMSOrderID",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Order Quantity",
      "db_columnname": "orderQuantity",
      "datatype": "Float",
      "mappingkey": "orderQuantity",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Route Quantity",
      "db_columnname": "routeQuantity",
      "datatype": "Float",
      "mappingkey": "routeQuantity",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Order Price",
      "db_columnname": "orderPrice",
      "datatype": "Float",
      "mappingkey": "orderPrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Route Price",
      "db_columnname": "routePrice",
      "datatype": "Float",
      "mappingkey": "routePrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Order Amount",
      "db_columnname": "orderAmount",
      "datatype": "Float",
      "mappingkey": "orderAmount",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Route Amount",
      "db_columnname": "routeAmount",
      "datatype": "Float",
      "mappingkey": "routeAmount",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Side",
      "db_columnname": "side",
      "datatype": "String",
      "mappingkey": "side",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Destination",
      "db_columnname": "destination",
      "datatype": "String",
      "mappingkey": "destination",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Customer",
      "db_columnname": "customer",
      "datatype": "String",
      "mappingkey": "customer",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Trader",
      "db_columnname": "trader",
      "datatype": "String",
      "mappingkey": "trader",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Bid Price",
      "db_columnname": "bidPrice",
      "datatype": "Float",
      "mappingkey": "bidPrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Ask Price",
      "db_columnname": "askPrice",
      "datatype": "Float",
      "mappingkey": "askPrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Route Bid Price",
      "db_columnname": "routeBidPrice",
      "datatype": "Float",
      "mappingkey": "routeBidPrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Route Ask Price",
      "db_columnname": "routeAskPrice",
      "datatype": "Float",
      "mappingkey": "routeAskPrice",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Creation Date",
      "db_columnname": "createDate",
      "datatype": "String",
      "mappingkey": "createDate",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   }
]